// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumBadge-cls1_Kpf","cls2":"PremiumBadge-cls2_kzH PremiumBadge-cls1_Kpf"};